import React from "react";

import { useNavigate } from "react-router-dom";

import { PALETTE } from "../../common/ThemeConstants";

export default function CardExercise({ exercise, isActive, to, height }) {
  const navigate = useNavigate();
  const desc =
    exercise.description.length > 28
      ? exercise.description.slice(0, 26) + ".."
      : exercise.description;

  const onClick = () => {
    navigate(to);
  };

  return (
    <div
      className={`text-start shadow-sm rounded-sm ${isActive ? "exercise-card" : ""}`}
      style={{
        backgroundImage: `url(${exercise.cover})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        cursor: "pointer",
        opacity: isActive ? 1 : 0.5,
        height: height,
        width: "100%",
        display: "flex",
        flexDirection: "column-reverse",
      }}
      onClick={onClick}
    >
      <div
        className="rounded-sm-bottom px-2 py-2"
        style={{
          height: "fit-content",
          background: PALETTE.VERTICALLINEARGRADIENTTRANSPARENTDARKINVERSE,
          color: PALETTE.WHITE
        }}>
        <span style={{ fontSize: 14, fontWeight: "bold" }}>
          {exercise.name}
        </span>
      </div>
    </div>
  );
}
